import { Paper } from "@mui/material";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { existeNomina, exportarExcelNomina, getNominaCompleta, setSearchedCuil } from "../../../redux/actions/nomina";
import { downloadFile } from "../../../util/files";
import HeaderForm from "../../commons/labels/HeaderForm";
import NominaCompletaTable from "./NominaCompletaTable";

const NominaCompletaContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const nominaCompleta = useSelector((state) => state.nomina.nominaCompleta);

  useEffect(() => {
    dispatch(getNominaCompleta());
  }, [dispatch]);

  const handleEdit = (cuil) => {
    const cleanCuil = String(cuil || "").replace(/\D/g, "");
    dispatch(setSearchedCuil(cleanCuil));
    dispatch(existeNomina(cleanCuil));
    navigate("/personal/ABMnominas", { state: { cuil: cleanCuil } });
  };

  const handleExport = () => {
    dispatch(exportarExcelNomina())
      .then((res) => {
        const fileName = res?.value?.fileName || "nomina_completa.csv";
        downloadFile(res.value.data, fileName);
      })
      .catch((err) => {
        toast.error("Ocurrió un error al descargar el archivo");
      });
  };

  const handleRefresh = () => {
    dispatch(getNominaCompleta());
  };

  return (
    <Paper>
      <HeaderForm title="Nómina Completa" />
      <NominaCompletaTable
        data={nominaCompleta.data || []}
        loading={nominaCompleta.loading}
        onEdit={handleEdit}
        onExport={handleExport}
        onRefresh={handleRefresh}
      />
    </Paper>
  );
};

export default NominaCompletaContainer;
